import { createSlice } from "@reduxjs/toolkit";
import { GetSupplierNames } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const supplierNameSlice = createSlice({
  name: "supplierNames",
  initialState: {
    supplierNameList: [],
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetSupplierNames.pending, () => {
      // toast.success('Promise Pending 🤯');
    });

    builder.addCase(GetSupplierNames.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');
      state.supplierNameList = action.payload
    });

    builder.addCase(GetSupplierNames.rejected, () => {
      toast.dismiss();
      toast.error('Promise rejected 😣')

    });
  },
});

export default supplierNameSlice.reducer;
